import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { openPullout } from '../../../../Actions/stakeholderActions';
import { constants } from '../../../../Helpers/Constants';
import Button from '../Button';
import colours from '../Colours';
import Icon from '../Icons/Icon';
import { CaptionMedium, CaptionSmall, P3, P3Bold, P4 } from '../Text';
import { connect } from "react-redux";

const VehicleStatusCard = ({ vehicle, ...props }) => {
    const [currentBooking, setCurrentBooking] = useState(null);
    const [cardType, setCardType] = useState('available');

    useEffect(() => {
        //determine status card type with the following checks:
        if (vehicle.current_booking_by_date) {
            setCurrentBooking(vehicle.current_booking_by_date);
            if (vehicle.current_booking_by_date && vehicle.current_booking_by_date.Book_Type == 2) {
                setCardType('service');
            } else if (moment(vehicle.Available_Date, "YYYY-MM-DD").startOf('day').isAfter(moment().startOf('day'))) {
                setCardType('incoming');
            }
            else if ((vehicle.Active !== 1) || (vehicle.Status === constants.vehicle_status.terminated) || (vehicle.status === 'Retired')) {
                setCardType('booking');
            }
        }
        if (vehicle.active_bookings && vehicle.active_bookings.length > 0) {
            vehicle.active_bookings.map((booking) => {
                if (moment().isSameOrAfter(moment(booking.Start_Date + " " + booking.Release_Time)) && moment().isSameOrBefore(moment(booking.End_Date + " " + booking.Return_Time))) {
                    setCardType('service');
                    setCurrentBooking(booking);
                }
            })
        }
        // if ((vehicle.Active !== 1) || (vehicle.Status === constants.vehicle_status.terminated) || (vehicle.status === 'retired')) {
        if (vehicle.status === 'retired') {
            setCardType('retired');
        }
    }, [])

    const retireVehicle = () => {
        if (vehicle && vehicle.V_ID)
            props.history.push(props.match.url + '/retire/' + vehicle.V_ID)
    }

    const onRelease = (e, book_id) => {
        e.stopPropagation();
        props.history.push(`${props.match.url}/release/${book_id}`);
    }

    const onReturn = (e, book_id) => {
        e.stopPropagation();
        props.history.push(`${props.match.url}/return/${book_id}`);
    }

    let data = {
        container: {
            available: 'ds-statuscard-container-green',
            booking: 'ds-statuscard-container-blue',
            retired: 'ds-statuscard-container-grey',
            service: 'ds-statuscard-container-grey',
            incoming: 'ds-statuscard-container-grey',
        },
        header: {
            available: 'ds-statuscard-header-green',
            booking: 'ds-statuscard-header-blue',
            retired: 'ds-statuscard-header-grey',
            service: 'ds-statuscard-header-grey',
            incoming: 'ds-statuscard-header-grey',
        },
        headerText: {
            available: "AVAILABLE",
            booking: "ON A BOOKING",
            retired: "RETIRED",
            service: "SERVICE",
            incoming: "INCOMING"
        },
        headerButton: {
            // available: <Button small tertiary leading_ic="RetireDate" label="Retire Vehicle" onClick={()=>{retireVehicle()}} color={colours.primary.white}/>,
            booking: <Button small tertiary leading_ic="Edit" label="Edit" onClick={() => { props.dispatch(openPullout(currentBooking, "edit")) }} color={colours.primary.white} />,
            service: <Button small tertiary leading_ic="Edit" label="Edit" onClick={() => { props.dispatch(openPullout(currentBooking, "edit")) }} color={colours.primary.white} />,
            // incoming: <Button small tertiary leading_ic="Edit" label="Edit" onClick={()=>{}} color={colours.primary.white}/>,
        },
        renderContent: {
            available: <AvailableContent data={vehicle} usageTypes={props.usageTypes} currentBooking={currentBooking} />,
            booking: <BookingContent data={vehicle} onReturn={onReturn} onRelease={onRelease} usageTypes={props.usageTypes} currentBooking={currentBooking} />,
            retired: <RetiredContent data={vehicle} />,
            service: <ServiceContent data={vehicle} onReturn={onReturn} onRelease={onRelease} currentBooking={currentBooking} />,
            incoming: <IncomingContent data={vehicle} />
        }
    }

    if (!data.renderContent[cardType]) return <></>;

    return (
        <div className={data.container[cardType]}>
            <div className={"ds-statuscard-header " + data.header[cardType]}>
                <P3Bold style={{ color: (cardType == 'request') ? colours.primary.grey01 : colours.primary.white }}>
                    {data.headerText[cardType]}
                </P3Bold>
                {data.headerButton[cardType]}
            </div>
            {data.renderContent[cardType]}
        </div>
    )
}

const BookingContent = (props) => {
    let currentBooking = props.currentBooking;

    const [hover, setHover] = useState(false);

    const handleMouseIn = () => {
        setHover(true);
    }

    const handleMouseOut = () => {
        setHover(false);
    }

    let tooltipStyle = {
        display: hover ? 'block' : 'none',
        position: 'absolute',
        background: '#FFFFFF',
        border: '1px solid #919EAB',
        boxSizing: 'border-box',
        borderRadius: '4px',
        padding: '12px',
    }

    let tooltipAfterStyle = {
        content: " ",
        position: 'absolute',
        bottom: '100%',  /* At the top of the tooltip */
        left: '20%',
        marginLeft: '-10px',
        borderWidth: '10px',
        borderStyle: 'solid',
        borderColor: 'transparent transparent #919EAB transparent',
    }

    var start = moment(currentBooking.Start_Date); //todays date
    var end = moment(currentBooking.End_Date); // another date
    var duration = moment.duration(start.diff(end));
    var days = duration.asDays();

    let releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05 };
    let returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05 };
    if (currentBooking.Released_On) {
        releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue };

        if (currentBooking.Returned_On) {
            returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue };
        }
    }

    return (
        <div className="ds-statuscard-content">
            <div className="ds-statuscard-content-row-space-between mt-4">
                <div className="ds-statuscard-content-row">
                    <div className="ds-statuscard-icon">
                        <Icon name="Release" size={24} style={releaseIconContainerStyle} />
                    </div>
                    <div>
                        <CaptionSmall>RELEASE</CaptionSmall>
                        <P3Bold>{moment(currentBooking.Start_Date).format('MMM DD, YYYY')}</P3Bold>
                    </div>
                </div>
                <div className="ds-statuscard-content-row">
                    <div className="ds-statuscard-icon">
                        <Icon name="CheckIn" size={24} style={returnIconContainerStyle} />
                    </div>
                    <div>
                        <CaptionSmall>RETURN</CaptionSmall>
                        <P3Bold>{moment(currentBooking.End_Date).format('MMM DD, YYYY')}</P3Bold>
                    </div>
                </div>
            </div>
            <div className="ds-statuscard-content-row mt-8">
                <P3Bold>{(currentBooking.profile?.First_Name ? currentBooking.profile?.First_Name : '') + " " + (currentBooking.profile?.Last_Name ? currentBooking.profile?.Last_Name : '')}</P3Bold>
            </div>
            <div className="ds-statuscard-content-row">
                <P4 style={{ color: colours.primary.grey02 }}>{currentBooking.profile?.Title ? currentBooking.profile?.Title + " at " + currentBooking.profile?.Company : null}</P4>
            </div>
            <div className="ds-statuscard-content-row-space-between mt-8">
                <P3>{props.usageTypes ? props.usageTypes['' + currentBooking.Usage_Type] : null}</P3>
                <P3>{Math.abs(Math.round(days)) + " Days"}</P3>
            </div>
            <div className="ds-statuscard-button-row">
                {currentBooking.Released_On ?
                    <div onMouseOver={() => { handleMouseIn() }} onMouseOut={() => { handleMouseOut() }}>
                        <Button tertiary small label="Release Information" />
                        <div style={tooltipStyle}>
                            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-evenly' }}>
                                {currentBooking.Odometer_Pre ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Mileage" size={24} style={releaseIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>MILEAGE:</CaptionMedium>
                                    </div>
                                    <P3Bold>{new Intl.NumberFormat().format(currentBooking.Odometer_Pre)} KM</P3Bold>
                                </div> : null}
                                {currentBooking.Fuel_Pre ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Mileage" size={24} style={releaseIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>FUEL:</CaptionMedium>
                                    </div>
                                    <P3Bold>{currentBooking.Fuel_Pre}/8</P3Bold>
                                </div> : null}
                                {currentBooking.Released_By ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="User" size={24} style={releaseIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>RELEASED BY:</CaptionMedium>
                                    </div>
                                    <P3Bold>{currentBooking.Released_By}</P3Bold>
                                </div> : null}
                                {currentBooking.Released_On ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Calendar" size={24} style={releaseIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>RELEASED ON:</CaptionMedium>
                                    </div>
                                    <P3Bold>{moment(currentBooking.Released_On).format('MMM DD, YYYY, h:mm A')}</P3Bold>
                                </div> : null}
                            </div>
                            <div style={tooltipAfterStyle}></div>
                        </div>
                    </div>
                    : <Button secondary small label="Release" onClick={(e) => { props.onRelease(e, currentBooking.BOOK_ID) }} />}
                {currentBooking.Returned_On ?
                    <div onMouseOver={() => { handleMouseIn() }} onMouseOut={() => { handleMouseOut() }}>
                        <Button tertiary small label="Return Information" />
                        <div style={tooltipStyle}>
                            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-evenly' }}>
                                {currentBooking.Odometer_Post ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Mileage" size={24} style={returnIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>MILEAGE:</CaptionMedium>
                                    </div>
                                    <P3Bold>{new Intl.NumberFormat().format(currentBooking.Odometer_Post)} KM</P3Bold>
                                </div> : null}
                                {currentBooking.Fuel_Post ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Mileage" size={24} style={returnIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>FUEL:</CaptionMedium>
                                    </div>
                                    <P3Bold>{currentBooking.Fuel_Post}/8</P3Bold>
                                </div> : null}
                                {currentBooking.Returned_By ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="User" size={24} style={returnIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>CHECKED IN BY:</CaptionMedium>
                                    </div>
                                    <P3Bold>{currentBooking.Returned_By}</P3Bold>
                                </div> : null}
                                {currentBooking.Returned_On ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Calendar" size={24} style={returnIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>CHECKED IN ON:</CaptionMedium>
                                    </div>
                                    <P3Bold>{moment(currentBooking.Returned_On).format('MMM DD, YYYY, h:mm A')}</P3Bold>
                                </div> : null}
                            </div>
                        </div>
                    </div>
                    : <Button secondary small label="Check In" onClick={(e) => { props.onReturn(e, currentBooking.BOOK_ID) }} disabled={currentBooking.Released_On ? false : true} />}
            </div>
        </div>
    )
}

const AvailableContent = (props) => {
    let data = props.data;

    if (data.next_booking) {
        let upcoming = data.next_booking;

        var start = moment(upcoming.Start_Date); //todays date
        var end = moment(upcoming.End_Date); // another date
        var duration = moment.duration(start.diff(end));
        var days = duration.asDays();

        let upcomingIconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue };
        return (
            <div className="ds-statuscard-content">
                <div className="ds-statuscard-content-row-space-between">
                    <div className="ds-statuscard-content-row mt-4">
                        <Icon name="Upcoming" style={upcomingIconContainerStyle} size={24} />
                        <CaptionMedium style={{ color: colours.primary.grey02, width: 50 }}>UPCOMING BOOKING:</CaptionMedium>
                    </div>
                    <div className="ds-statuscard-content-row mt-8">
                        <P3Bold>{moment(upcoming.Start_Date).format('MMM DD, YYYY')}</P3Bold>
                    </div>
                </div>
                <div className="ds-statuscard-content-row mt-8">
                    <P3Bold>{(upcoming.profile.First_Name ? upcoming.profile.First_Name : '') + " " + (upcoming.profile.Last_Name ? upcoming.profile.Last_Name : '')}</P3Bold>
                </div>
                <div className="ds-statuscard-content-row">
                    <P4 style={{ color: colours.primary.grey02 }}>{upcoming.profile.Title ? upcoming.profile.Title + " at " + upcoming.profile.Company : null}</P4>
                </div>
                <div className="ds-statuscard-content-row-space-between mt-8">
                    <P3>{props.usageTypes ? props.usageTypes['' + upcoming.Usage_Type] : null}</P3>
                    <P3>{Math.abs(Math.round(days)) + " Days"}</P3>
                </div>
            </div>
        )
    } else {
        return null;
    }
}

const RetiredContent = ({ data }) => {
    let iconContainerStyle = { marginRight: 4, borderRadius: '8px' };

    return (
        <div className="ds-statuscard-content">
            <div className="ds-statuscard-content-row-space-between mt-4">
                <div className="ds-statuscard-content-row">
                    <Icon name="RetireDate" class='ds-activity-card-icon' style={iconContainerStyle} size={24} />
                    <CaptionMedium style={{ color: colours.primary.grey02 }}>RETIRED ON:</CaptionMedium>
                </div>
                <div className="ds-statuscard-content-row">
                    <P3Bold>{moment(data.terminatedAt).format('MMM DD, YYYY')}</P3Bold>
                </div>
            </div>
            {/* <div className="ds-statuscard-button-row-centered">
                <Button secondary small label="Reactivate Vehicle" onClick={()=> {}}/>
            </div> */}
        </div>
    )
}

const ServiceContent = (props) => {
    let currentBooking = props.currentBooking;

    const [hover, setHover] = useState(false);

    const handleMouseIn = () => {
        setHover(true);
    }

    const handleMouseOut = () => {
        setHover(false);
    }

    let tooltipStyle = {
        display: hover ? 'block' : 'none',
        position: 'absolute',
        background: '#FFFFFF',
        border: '1px solid #919EAB',
        boxSizing: 'border-box',
        borderRadius: '4px',
        padding: '12px',
    }

    let tooltipAfterStyle = {
        content: " ",
        position: 'absolute',
        bottom: '100%',  /* At the top of the tooltip */
        left: '20%',
        marginLeft: '-10px',
        borderWidth: '10px',
        borderStyle: 'solid',
        borderColor: 'transparent transparent #919EAB transparent',
    }

    let releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05 };
    let returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05 };
    if (currentBooking.Released_On) {
        releaseIconContainerStyle = { borderRadius: '8px' };

        if (currentBooking.Returned_On) {
            returnIconContainerStyle = { borderRadius: '8px' };
        }
    }

    return (
        <div className="ds-statuscard-content">
            <div className="ds-statuscard-content-row-space-between mt-4">
                <div className="ds-statuscard-content-row">
                    <div className="ds-statuscard-icon">
                        <Icon name="Release" size={24} class='ds-activity-card-icon' style={releaseIconContainerStyle} />
                    </div>
                    <div>
                        <CaptionSmall>RELEASE</CaptionSmall>
                        <P3Bold>{moment(currentBooking.Start_Date).format('MMM DD, YYYY')}</P3Bold>
                    </div>
                </div>
                <div className="ds-statuscard-content-row">
                    <div className="ds-statuscard-icon">
                        <Icon name="CheckIn" size={24} class='ds-activity-card-icon' style={returnIconContainerStyle} />
                    </div>
                    <div>
                        <CaptionSmall>RETURN</CaptionSmall>
                        <P3Bold>{moment(currentBooking.End_Date).format('MMM DD, YYYY')}</P3Bold>
                    </div>
                </div>
            </div>
            <div className="ds-statuscard-content-row mt-8">
                <P3Bold>{(currentBooking.Release_To ? currentBooking.Release_To : '')}</P3Bold>
            </div>
            <div className="ds-statuscard-content-row">
                <P4 style={{ color: colours.primary.grey02 }}>{(currentBooking.Vehicle_Usage ? currentBooking.Vehicle_Usage : '')}</P4>
            </div>
            <div className="ds-statuscard-button-row">
                {currentBooking.Released_On ?
                    <div onMouseOver={() => { handleMouseIn() }} onMouseOut={() => { handleMouseOut() }}>
                        <Button tertiary small label="Release Information" />
                        <div style={tooltipStyle}>
                            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-evenly' }}>
                                {currentBooking.Odometer_Pre ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Mileage" size={24} class='ds-activity-card-icon' style={releaseIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>MILEAGE:</CaptionMedium>
                                    </div>
                                    <P3Bold>{new Intl.NumberFormat().format(currentBooking.Odometer_Pre)} KM</P3Bold>
                                </div> : null}
                                {currentBooking.Fuel_Pre ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Mileage" size={24} class='ds-activity-card-icon' style={releaseIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>FUEL:</CaptionMedium>
                                    </div>
                                    <P3Bold>{currentBooking.Fuel_Pre}/8</P3Bold>
                                </div> : null}
                                {currentBooking.Released_By ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="User" size={24} class='ds-activity-card-icon' style={releaseIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>RELEASED BY:</CaptionMedium>
                                    </div>
                                    <P3Bold>{currentBooking.Released_By}</P3Bold>
                                </div> : null}
                                {currentBooking.Released_On ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Calendar" class='ds-activity-card-icon' size={24} style={releaseIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>RELEASED ON:</CaptionMedium>
                                    </div>
                                    <P3Bold>{moment(currentBooking.Released_On).format('MMM DD, YYYY, h:mm A')}</P3Bold>
                                </div> : null}
                            </div>
                            <div style={tooltipAfterStyle}></div>
                        </div>
                    </div>
                    : <Button secondary small label="Release" onClick={(e) => { props.onRelease(e, currentBooking.BOOK_ID) }} />}
                {currentBooking.Returned_On ?
                    <div onMouseOver={() => { handleMouseIn() }} onMouseOut={() => { handleMouseOut() }}>
                        <Button tertiary small label="Return Information" />
                        <div style={tooltipStyle}>
                            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-evenly' }}>
                                {currentBooking.Odometer_Post ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Mileage" class='ds-activity-card-icon' size={24} style={returnIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>MILEAGE:</CaptionMedium>
                                    </div>
                                    <P3Bold>{new Intl.NumberFormat().format(currentBooking.Odometer_Post)} KM</P3Bold>
                                </div> : null}
                                {currentBooking.Fuel_Post ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Mileage" class='ds-activity-card-icon' size={24} style={returnIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>FUEL:</CaptionMedium>
                                    </div>
                                    <P3Bold>{currentBooking.Fuel_Post}/8</P3Bold>
                                </div> : null}
                                {currentBooking.Returned_By ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="User" class='ds-activity-card-icon' size={24} style={returnIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>CHECKED IN BY:</CaptionMedium>
                                    </div>
                                    <P3Bold>{currentBooking.Returned_By}</P3Bold>
                                </div> : null}
                                {currentBooking.Returned_On ? <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 12 }}>
                                        <Icon name="Calendar" class='ds-activity-card-icon' size={24} style={returnIconContainerStyle} />
                                        <CaptionMedium style={{ color: colours.primary.grey02, marginLeft: 10 }}>CHECKED IN ON:</CaptionMedium>
                                    </div>
                                    <P3Bold>{moment(currentBooking.Returned_On).format('MMM DD, YYYY, h:mm A')}</P3Bold>
                                </div> : null}
                            </div>
                        </div>
                    </div>
                    : <Button secondary small label="Check In" disabled={currentBooking.Released_On ? false : true} onClick={(e) => { props.onReturn(e, currentBooking.BOOK_ID) }} />}
            </div>
        </div>
    )
}

const IncomingContent = ({ data }) => {
    let iconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue };

    return (
        <div className="ds-statuscard-content">
            <div className="ds-statuscard-content-row-space-between mt-4">
                <div className="ds-statuscard-content-row">
                    <Icon name="AvailableDate" class='ds-activity-card-icon' style={iconContainerStyle} size={24} />
                    <CaptionMedium style={{ color: colours.primary.grey02 }}>AVAILABLE DATE:</CaptionMedium>
                </div>
                <div className="ds-statuscard-content-row">
                    <P3Bold>{moment(data.Available_Date).format('MMM DD, YYYY')}</P3Bold>
                </div>
            </div>
            <div className="ds-statuscard-button-row-centered">
                {/* <Button secondary small label="Check In" onClick={()=> {}}/> */}
            </div>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings,
    stakeholder: store.stakeholder
});

export default connect(mapStateToProps)(VehicleStatusCard);